import React, {ReactElement} from 'react';
import mailLogo from '@assets/images/medops/mail_check_logo.svg';
const MailCheckLogo = (props: any): ReactElement => {
  return (
    <img
      src={mailLogo}
      // height={'100%'}
      // width={'100%'}
      {...props}
    />
  );
};
export default MailCheckLogo;
